export const dateTimeFormat = {
  local: 'en-GB',
};

export const isDateWithinRange = (
  dateToCheck: string,
  startDate?: string,
  endDate?: string
): boolean => {
  const checkDate = new Date(dateToCheck);
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;
  if (end) end.setUTCDate(end.getUTCDate() + 1);

  if (start && checkDate < start) return false;
  if (end && checkDate >= end) return false;

  return true;
};
